// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__IbM_a","image":"Error_image__BCbwb","title":"Error_title__CHKEb","description":"Error_description__uj3pX","homeLink":"Error_homeLink__mKMQb"};